<template>
  <div class="check-table-body-item">
    <div class="item-text">
      <i v-if="!hiddenDot" class="small-dot"/>
      <span>{{ value.text }}</span>
    </div>
    <div class="h-full border-left" style="display: flex; justify-content: center; align-items: center;">
      <span>{{ value.cycle }}</span>
    </div>
    <div class="item-value" v-for="(result, index) in dataTypes" :key="`${value.text}_${result}_${index}`">
      <span v-if="value.data && isPrint && value.data[index]">
        <feather-icon icon="CheckIcon" style="width:21px; height: 21px;" />
      </span>
      <vs-checkbox v-else-if="value.data && !isPrint" name="check-table-body-item" v-model="value.data[index]" @input="()=>{onChange(index)}"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckTableBodyItem',
  props: {
    dataTypes: Array,
    value: Object,
    isPrint: Boolean,
    hiddenDot: Boolean,
  },
  methods: {
    onChange (index) {
      if (this.value.data[index] === false) {

      } else {
        let i = 0
        const start = Math.floor(index / 5) * 5
        for (i = start; i < start + 5; i++) {
          this.value.data[i] = (index === i)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-text {
  display: flex;
  align-items: center;
}
.item-value {
  border-left: 1px solid #cdcdcd;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}
.small-dot {
  min-width: 4px;
  min-height: 4px;
  width: 4px;
  height: 4px;
  background-color: #3C3C3C;
  border-radius: 2px;
  margin-right: 8px;
}
.check-table-body-item {
  display: grid;
  grid-template-columns: 1fr 43px repeat(10, 50px);
  min-height: 50px;
  align-items: center;
  padding-left: 1rem;
  background-color: #fff;

  border-left: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;

  &:hover {
    background-color: aliceblue;
  }
}
</style>
